import React from "react";

const Card = props => {
  const cardStyle = {
    backgroundColor: `${props.cardColor}`,
    backgroundSize: "cover",
    border: `${props.cardBorderColor}`,
  };

  const headerStyle = {
    height: `${props.headerHeight}`,
    backgroundColor: `${props.headerColor}`,
    color: `${props.headerTextColor}`
  };
  
  const footerStyle = {
    backgroundColor: `${props.footerColor}`
  };

  const blockStyle = {
    padding: `${props.blockPadding}`
  };

  return (
    <div
      className={`card card-${props.cardType} ${props.className}`}
      style={props.cardStyle ? props.cardStyle : cardStyle}
    >
      {props.cardHeader ? (
        <div className="card-header" style={headerStyle}>
          {props.cardHeader}
        </div>
      ) : null}
      {props.cardImg ? (
        <img
          className="card-img-top img-responsive"
          src={props.cardImg}
          alt=""
        />
      ) : null}
      <div className="card-block" style={blockStyle}>
        <div>
          {props.cardBody}
          {props.children}
        </div>
        {props.cardButtonText ? (
          <a href={props.cardButtonUrl} className="btn btn-default">
            {props.cardButtonText}
          </a>
        ) : null}
      </div>
      {props.cardFooter ? (
        <div class="card-footer" style={footerStyle}>
          {props.cardFooter}
        </div>
      ) : null}
    </div>
  );
};
export default Card;
